module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("本院影像")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "conten"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("此模块归属于“资料中心”，用户可在此进行影像查询、影像调阅、影像标记、报告查看、以及相关历史影像查看、收藏影像到病例库等操作。")]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', [_c('template', {
    slot: "title"
  }, [_vm._v("\n                  影像查询\n            ")]), _vm._v(" "), _c('div', [_c('P', {
    staticClass: "text"
  }, [_vm._v("\n                在下图中的查询条件中选择“检查时间（可自定义选择）、检查类型、就诊类别、选择医院”，也可输入“患者信息”，点击“查询”按钮，如果有结果，查询结果列表里会出现相应的结果，如果没有符合查询条件的结果，则页面上方会提示“未查询到符合条件的记录”。\n              点击“重置”按钮，可以将查询条件恢复成默认状态。勾选“读片”，则查询结果列表只显示被标记过的影像。\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/image/data.png")
    }
  })])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "影像操作"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("影像操作包含“报告、阅片、收藏、读片”四个操作，如图所示。")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/operation.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1)点击查询结果列表中的“操作”字段中的“报告”按钮"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/63.png")
    }
  })]), _vm._v("（无报告时，按钮置灰，不可点击），页面跳转到“查看报告界面”，如下图所示。可进行申请单、历史检查、电子病历查看，支持多个检查同时对比阅片。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/Check.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2)点击查询结果列表中的“操作”字段中的“阅片”按钮"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/64.png")
    }
  })]), _vm._v("（无影像时，按钮置灰，不可点击），页面跳转到“阅片界面”，如下图所示。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/readFilm.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("3)点击查询结果列表中的“操作”字段中的“收藏”按钮"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/65.png")
    }
  })]), _vm._v("，页面跳转到“收藏界面”，如下图所示，可收藏至典型病例库。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/Collection.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("4)检查标记——点击查询结果列表中的“操作”字段中的“读片”按钮"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/66.png")
    }
  })]), _vm._v("，会跳出一个提示框，如图所示，点击“确定”按钮，病例标记成功，“读片”按钮变成实心"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/67.png")
    }
  })]), _vm._v("，标记过读片的病例可单独查询。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/btn.png")
    }
  })])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1c773196","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/ImageHospital/ImageHospital.vue
// module id = 534
// module chunks = 1 2 3 4 5 6 7 8